/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import { Link } from '@one-thd/sui-atomic-components';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import '../../styles/store-selector.scss';
import classNames from 'classnames';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { InStorePopover } from './InStoreRefinmentPopover';
import { ChangeStore } from '../StoreSelector/ChangeStore';
import { useInStoreState } from './useInStoreState';

export const InChangeStore = () => {
  const { channel, isConsumerApp } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const {
    changeStore,
    isNearbyStores,
    storeSearch,
    toggleChangeStore,
    address,
    storeName
  } = useInStoreState();

  // Early return - don't render anything in case of mobile consumer app
  if (isMobile && isConsumerApp) {
    return null;
  }

  const storeSelectorClassName = classNames('store-selector sui-w-max', {
    'store-selector--mobile sui-mt-1': isMobile
  });

  const contentClasses = classNames('store-selector__content', {
    'store-selector__content--mobile': isMobile
  });

  return (
    <div className={storeSelectorClassName}>
      { (!isMobile && (
        <Tooltip
          channel="desktop"
          closeButton
          placement="right"
          portal
          content={(
            <div className={contentClasses}>
              <ChangeStore
                postalCode={address?.postalCode}
                stores={storeSearch}
                onChangeClick={toggleChangeStore}
                hideCancelBtn
              />
            </div>
          )}
        >
          <div
            className="sui-font-regular sui-text-base sui-flex sui-mt-2 sui-leading-tight sui-items-center"
          >
            <span className="sui-px-1">at</span>
            <button
              type="button"
              className="sui-pr-1 sui-flex sui-items-center sui-gap-1"
              aria-label="store selector caret"
              tabIndex="0"
              onClick={toggleChangeStore}
            >
              <Link underline="always">
                <div className="sui-truncate store-selector__dropdown-max-width">
                  {storeName}  {
                    isNearbyStores && '& nearby stores'
                  }
                </div>

              </Link>
            </button>
          </div>
        </Tooltip>
      ))}

      {(isMobile) && (
        <InStorePopover
          isVisible={changeStore}
          text="at"
          linkText={(
            <div className="sui-truncate store-selector--mobile__dropdown-max-width">
              {storeName}  {
                isNearbyStores && '& nearby stores'
              }
            </div>
          )}
          isLinkType
          popoverContent={(
            <ChangeStore
              postalCode={address.postalCode}
              stores={storeSearch}
              onChangeClick={toggleChangeStore}
              hideCancelBtn
            />
          )}
        />
      )}
    </div>
  );
};
